export * from './organ-transplant.model';
export * from './organ-transplant.service';
